export default __webpack_public_path__ + "beta-maps-guides-migrate-approximate-location-1200-3b74ef7818a5372334b44c51adcfd8e5.webp";